
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/c/[slug]",
      function () {
        return require("private-next-pages/default/desktop/c/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/c/[slug]"])
      });
    }
  